import omnivore from 'leaflet-omnivore'
import store from '@/store'

const SHAPE_ESTADO = store.state.userInterface.dadosEstado.SHAPE_ESTADO

const ufTopoJson = () => import('./seeds/' + SHAPE_ESTADO)

class TopoJsonHelper {
  static getTopoJson () {
    return new Promise((resolve) => {
      ufTopoJson().then((results) => {
        const layerUf = omnivore.topojson.parse(results.layer)

        layerUf.setStyle({
          fill: true,
          fillColor: 'transparent',
          weight: 1.5,
          color: '#c8c8c8'
        })

        resolve(layerUf)
      })
    })
  }
}
export default TopoJsonHelper



// WEBPACK FOOTER //
// ./src/libs/static/uf/topoJsonHelper.js